import SelectPlaceholder from "./SelectPlaceholder";

export default function SelectNoResults(props: { searchTerm: string }) {
  return (
    <SelectPlaceholder>
      {props.searchTerm === "" ? "No results" : `No results for "${props.searchTerm}"`}
    </SelectPlaceholder>
  );
}
